import "./AppHeader.scss";

import React, { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import MonadSelect from "ui/build/components/MonadSelect/MonadSelect";

import { fetchRuntimeConfig } from "../../utils/fetchRuntimeConfig";
import MainContainer from "../main-container/MainContainer";
import SubtenantSelector from "./ChangeSubtenant/SubtenantSelector";
import Notifications from "./Notifications/Notifications";
import RheaSideNav from "./RheaSideNav/RheaSideNav";
import UserProfile from "./UserProfile/UserProfile";
const VIEW_CASES_ROUTE = "/viewcases";

const AppHeader = () => {
  const loginResponse = JSON.parse(localStorage.getItem("loginResponse"));
  const subTenants = loginResponse?.object?.subtenants;
  const productCategories = loginResponse?.object?.productCategories || [];
  const tenantDetailsParsed = JSON.parse(localStorage.getItem("tenantDetails"));
  const subtenantID = tenantDetailsParsed?.subtenantId;
  const [notificationConfig, setNotificationConfig] = useState("false");
  const lastActiveProductCategory = loginResponse?.object?.lastActiveProductCategory;
  const persistedProductCategory = sessionStorage.getItem("productCategory");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const config = await fetchRuntimeConfig();
        Object.defineProperty(window, "__APP_RUNTIME_CONFIG__", {
          value: Object.freeze(config),
          writable: false,
        });
        setNotificationConfig(config?.enableAlerts);
      } catch (error) {
        console.error("error", error);
        setNotificationConfig("false");
      }
    };
    fetchConfig();
  }, []);

  const history = useHistory();
  const categoryOptions = productCategories.map((cat) => ({ value: cat, label: cat }));
  const defaultCategoryValue = "Drug";
  const isValidCategory = (cat) => productCategories.some((pc) => String(pc) === String(cat));

  let resolvedInitialCategory = defaultCategoryValue;

  if (persistedProductCategory && isValidCategory(persistedProductCategory)) {
    resolvedInitialCategory = persistedProductCategory;
  } else if (lastActiveProductCategory && isValidCategory(lastActiveProductCategory)) {
    resolvedInitialCategory = lastActiveProductCategory;
  }

  const initialSelectedCategory = { value: resolvedInitialCategory, label: resolvedInitialCategory };

  const [selectedCategory, setSelectedCategory] = useState(initialSelectedCategory);

  useEffect(() => {
    if (selectedCategory) {
      const value = selectedCategory?.value?.toLowerCase() || "";
      const cosmeticsFlag = value === "cosmetics";
      try {
        sessionStorage.setItem("isCosmetics", cosmeticsFlag ? "true" : "false");
        sessionStorage.setItem("productCategory", selectedCategory?.value || "");
        const updatedLoginResponse = JSON.parse(localStorage.getItem("loginResponse"));
        if (updatedLoginResponse?.object) {
          updatedLoginResponse.object.lastActiveProductCategory = selectedCategory?.value || "";
          localStorage.setItem("loginResponse", JSON.stringify(updatedLoginResponse));
        }
      } catch (err) {
        console.error("persist product category", err);
      }
    }
  }, [selectedCategory]);

  const handleChangeCategory = (option) => {
    if (isCategoryDisabled) return;
    const nextCategory = option?.value || "";
    const currentCategory = selectedCategory?.value || "";
    if (nextCategory && nextCategory !== currentCategory) {
      sessionStorage.removeItem("caseId");
      if (window.location.pathname.startsWith(VIEW_CASES_ROUTE)) {
        history.replace({ pathname: VIEW_CASES_ROUTE, search: "" });
      }
    }
    setSelectedCategory(option);
  };

  const pathname = window.location.pathname || "";
  const allowCaseAssignment = pathname.startsWith("/caseassignment");
  const isCategoryDisabled =
    !allowCaseAssignment && (pathname.startsWith("/case") || window.location.href.includes("/case/"));

  return (
    <div className="global-container">
      <RheaSideNav />
      <div className="nav-header-main-content">
        <div className="navbar-header">
          <Navbar style={{ boxShadow: "2px 2px 7px 0px #e5e5e5" }}>
            <Nav style={{ position: "absolute", left: 10 }}>
              <img src={`/assets/DF mSafety AI.png`} alt={"mSafety logo"} style={{ height: "30px" }} />
            </Nav>
            <Nav style={{ position: "absolute", left: 120 }}>
              <div
                style={{ width: "170px", height: "86px" }}
                className={isCategoryDisabled ? "category-select-disabled" : ""}
              >
                <MonadSelect
                  options={categoryOptions}
                  value={selectedCategory}
                  onChange={handleChangeCategory}
                  name="category"
                  AutoComplete
                  placeholder={"Product Category"}
                  isDisabled={isCategoryDisabled}
                  menuIsOpen={isCategoryDisabled ? false : undefined}
                  maxMenuHeight={150}
                />
              </div>
            </Nav>
            <Nav className="mx-auto center-dropdown-container">
              <SubtenantSelector subTenants={subTenants} subtenantID={subtenantID} history={history} />
            </Nav>
            <div style={{ borderLeft: "1px solid #cfc9c9", height: "50px", paddingRight: "20px" }}></div>
            {(() => {
              if (notificationConfig === "true") {
                return <Notifications pollingInterval={600000} />;
              } else if (notificationConfig && !isNaN(Number(notificationConfig))) {
                return <Notifications pollingInterval={Number(notificationConfig)} />;
              }
              return null;
            })()}
            <div style={{ paddingRight: "20px" }}></div>
            <UserProfile />
          </Navbar>
        </div>
        <div className="main-container">
          <MainContainer />
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
